import { axios } from '@/lib/axios';
import { OutputErrorLog } from '@/lib/error';

export type CompleteTaskDTO = {
  data: { completeDate: string };
  siteId: number;
  constructionZoneId: number;
  taskId: number;
};

// 作業完了日を登録するAPI
export const completeTask = async ({
  data,
  siteId,
  constructionZoneId,
  taskId,
}: CompleteTaskDTO) => {
  try {
    await axios.patch(
      `/sites/${siteId}/construction-zones/${constructionZoneId}/tasks/${taskId}/complete`,
      data
    );
  } catch (error) {
    OutputErrorLog('completeTask', error);
    throw error;
  }
};
